import { render, staticRenderFns } from "./Headers.vue?vue&type=template&id=4b5c3780&scoped=true&"
import script from "./Headers.vue?vue&type=script&lang=js&"
export * from "./Headers.vue?vue&type=script&lang=js&"
import style0 from "./Headers.vue?vue&type=style&index=0&id=4b5c3780&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5c3780",
  null
  
)

export default component.exports